export const Speciality = [
    { name: 'CARDIAC', code: 'CARDIAC' },
]